import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { AppTableComponent, ModalWindowComponent, SearchModel, SearchResultModel, SupplierRoundListModel, SupplierRoundListService, Auth, MessagesComponent, SearchCache } from 'src/common';
import { TranslationManager } from 'src/common/translation';
import { Router } from '@angular/router';



@Component({
  selector: 'app-supplier-round-list-ssy1190list',
  templateUrl: './supplier-round-list-ssy1190list.component.html'
})
export class SupplierRoundListSsy1190listComponent implements AfterViewInit {

  displayParticipateModal: boolean = false;
  participateQuestion: string;
  idForParticipate: number;
  participateFlagIsConfirmed: boolean;

  constructor(private router: Router, private supplierRoundListViewService: SupplierRoundListService) { }

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("modalWindow") modalWindow: ModalWindowComponent;
  translationManager = TranslationManager;
  items: SupplierRoundListModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;
  customHeaderText = '';

  ngAfterViewInit(): void {
    this.appTable.onSearch = this.doSearch.bind(this);
    this.appTable.search();
  }

  doSearch(search: SearchModel) {
    this.supplierRoundListViewService.search(search).then((result: SearchResultModel<SupplierRoundListModel>) => {
      this.items = result.items;
      this.appTable.setTotalCount(result.totalCount);
    })
  }

  create() {
    this.routerNavigateToCreate();
  }

  openDetails(id: number) {
    this.router.navigate(['/supplierRoundLists/details/' + id]);
  }

  delete() {
    this.showDeleteModal = false;
    this.supplierRoundListViewService.delete(this.idForDelete).then(() => {
      this.supplierRoundListViewService.getAll().then((items: SupplierRoundListModel[]) => {
        this.items = items;
      });
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
    });
  }

  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  private routerNavigateToCreate() {
    this.router.navigate(['supplier-round-list/create']);
  }

  showParticipateModalFor(id: number, participateFlag: boolean) {
    this.participateFlagIsConfirmed = participateFlag;
    this.idForParticipate = id;
    this.displayParticipateModal = true;
    if (this.participateFlagIsConfirmed) {
      this.participateQuestion = this.translationManager.getTranslation("SupplierRoundList_ParticipateQustion");
    }
    else {
      this.participateQuestion = this.translationManager.getTranslation("SupplierRoundList_NotParticipateQustion");
    }
  }

  partcipate() {
    let status;
    if (this.participateFlagIsConfirmed) {
      status = 'AttendanceConfirmed';
    }
    else {
      status = 'AttendanceCancelled';
    }
    this.supplierRoundListViewService.changeStatus({ 'id': this.idForParticipate, 'status': status }).then(() => {
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно сачуван ентитет')]);
      this.displayParticipateModal = false;
      this.appTable.onSearch = this.doSearch.bind(this);
      this.appTable.search();
    }).catch((reason: any) => {
      this.displayParticipateModal = false;
      if (reason !== null) {
        if (reason.status === 400) {
          if (reason.error !== null) {
            if (reason.error.message) {
              const mescustom = reason.error.message;
              MessagesComponent.instance.showError([mescustom]);

            }
          }
        } else {
          MessagesComponent.instance.showError(reason.error.messages);
        }
      }
    });
  }

  isColored(item: SupplierRoundListModel): boolean {
    let bold = false ;

    if(item.requestRoundStatusUniqueIdentifier === 'Initiated' && item.requestRoundSupplierStatusUniqueIdentifier ==='AttendanceRequested'){

      bold = true;

    }
    if(item.requestRoundStatusUniqueIdentifier === 'SupplierSelected' ){

      bold = true;

    }
    if(item.requestRoundStatusUniqueIdentifier === 'Initiated' && item.requestRoundSupplierStatusUniqueIdentifier ==='OfferSubmitted'){

      bold = true;
     }
    return bold;

  }

 tableRowColored(item: SupplierRoundListModel): string {

      let color = '';

    //Status runde - pokrenuta + status ponude  poslat poziv zuto
    if(item.requestRoundStatusUniqueIdentifier === 'Initiated' && item.requestRoundSupplierStatusUniqueIdentifier ==='AttendanceRequested'){

      // color = '#FFFF00'; // - Yellow
      color = '#FAFA33'; //Lemon Yellow
      color = '#FFBF00';

    }

     //Status runde - pokrenuta + status ponude  poslata ponude  zeleno
    if(item.requestRoundStatusUniqueIdentifier === 'Initiated' && item.requestRoundSupplierStatusUniqueIdentifier ==='OfferSubmitted'){

     // color = '#008000'; // -Green
     // color = '#00FF00'; // -Lime
     // color = '#9FE2BF'; //Seafoam Green
     // color = '#00FF7F'; // Spring Green
      color = '#009E60'; // Shamrock Green

    }

     //Status runde - izabran dobavljač   svetlo plavo
     if(item.requestRoundStatusUniqueIdentifier === 'SupplierSelected' ){

      //color = '#0000FF';  // - Blue
      //color = '#00FFFF'; // - Aqua
      color = '#87CEEB'; // - Sky Blue

    }
    // status runde otkazana crvena
    if(item.requestRoundStatusUniqueIdentifier === 'Cancelled'){
      color = '#FF0000'; // - Red
      color = '#FF3131'; // - Neon Red
    }

    return color;
  }


}

// Portal u segmentu Nabavke: https://htmlcolorcodes.com/colors/
// sve nabavke koje su u statusu runde pokrenuta + status ponude u statusu poslat poziv - boldovane + svetlo žute
// status runde pokrenuta+status ponude poslata ponuda - svetlo zelene
// status runde izabran dobavljač boldovano + svetlo plavo
// Za nabavke za koje je otkazana nabavka - crveno
